import React, { useState, useEffect } from "react";
import moment from "moment";
import { map, reduce } from "lodash";
import { Button, Icon } from "antd";
import {
  displayRecapPaymentCsvFile, displayRecapPaymentPdfFile,
  getRecapByDay
} from "../../../actions/thunks/statistics";
import { setFilterInvoicesByDay } from "../../../actions/actions/statistics";
import { connect } from "react-redux";
import { Tabs } from 'antd';
import { formatAmount } from "utils";
import _ from "i18n";

const { TabPane } = Tabs;

const RecapByDate = ({
  statisticsFilter,
  recapByDay,
  auth,
  operationType,
  changeState,
  getRecapByDay,
  setFilterInvoicesByDay,
  displayRecapPaymentCsvFile,
  displayRecapPaymentPdfFile
}) => {


  const [date, setDate] = useState('jour');

  const loadRecapByDay = () => {
    getRecapByDay(
      statisticsFilter.apps || [],
      statisticsFilter.appRefs || [],
      operationType || null,
      auth.currentClient ? auth.currentClient.id : null,
      statisticsFilter.year || [],
      statisticsFilter.appType || []
    );
  };

  useEffect(() => {
    if (statisticsFilter.apps && statisticsFilter.apps.length > 0) {
      loadRecapByDay();
    }
  }, []);

  useEffect(() => {
    if (operationType !== null) {
      loadRecapByDay();
    }
  }, [operationType]);



  const constructMonthBloc = ({ amount, month }) => {

    return (
      <div>

        <div className="flex flex-row justify-between">
          <div className={recapByDay.filterDay == month ? "div-day-recap div-day-recap-active" : "div-day-recap"} onClick={() => {
            setDayFilter(month)
          }}>
            {moment(month).format("MM/YYYY")}
          </div>
          <div className=" self-end pr-4  div-recap-amount">
            {formatAmount(amount)}
          </div>
        </div>
        <div className="line" />
      </div>
    )

  }

  const constructDayBloc = ({ amount, day }) => {

    return (
      <div>

        <div className="flex flex-row justify-between">
          <div className={recapByDay.filterDay == day ? "div-day-recap div-day-recap-active" : "div-day-recap"} onClick={() => {
            setDayFilter(day)
          }}>
            {moment(day).format("DD/MM/YYYY")}
          </div>
          <div className=" self-end pr-4  div-recap-amount">
            {formatAmount(amount)}
          </div>
        </div>
        <div className="line" />
      </div>
    )

  }

  const calculSum = () => {
    return reduce(recapByDay.items['month'], (sum, { amount }) => (sum + parseInt(amount)), 0);
  }


  const toggleDayChecked = () => {

    setFilterInvoicesByDay(null)
  }

  const setDayFilter = (date) => {

    setFilterInvoicesByDay(date)
  }

  const getCsvFile = () => {
    changeState(true);
    displayRecapPaymentCsvFile(statisticsFilter.apps && statisticsFilter.apps.length > 0 ? statisticsFilter.apps : [], statisticsFilter.appRefs && statisticsFilter.appRefs.length > 0 ? statisticsFilter.appRefs : [], operationType ? operationType : null, date, auth.currentClient ? auth.currentClient.id : null, statisticsFilter.year && statisticsFilter.year.length > 0 ? statisticsFilter.year : [], statisticsFilter.appType && statisticsFilter.appType.length > 0 ? statisticsFilter.appType : []).then((res) => {
      changeState(false);
    });
  }

  const getPdfFile = () => {
    changeState(true);
    displayRecapPaymentPdfFile(statisticsFilter.apps && statisticsFilter.apps.length > 0 ? statisticsFilter.apps : [], statisticsFilter.appRefs && statisticsFilter.appRefs.length > 0 ? statisticsFilter.appRefs : [], operationType ? operationType : null, date, auth.currentClient ? auth.currentClient.id : null, statisticsFilter.year && statisticsFilter.year.length > 0 ? statisticsFilter.year : [], statisticsFilter.appType && statisticsFilter.appType.length > 0 ? statisticsFilter.appType : []).then((res) => {
      changeState(false);
    });
  }

  const callback = (key) => {

    setDate(key);
  }

  if (!recapByDay || !recapByDay.items['month'] || recapByDay.items.length === 0) {

    return <div>

    </div>
  }

  return (
    <div className="recap-day-container pl-4">

      <div className="flex flex-row justify-between align-center pt-8" >

        <div className="recap-day-title">
          {_('Date')}
        </div>

      </div>
      <div className="pt-8 mb-2">

        <Button type={recapByDay.filterDay === null ? 'primary' : 'default'} data-operation="ALL" onClick={() => toggleDayChecked()}>{_('ALL')} </Button>

      </div>


      <div className="flex relative">

        <Tabs onChange={callback} type="card">
          <TabPane tab=" Jour " key="jour">
            <div className="pt-4 scroll-div-recap w-48">
              {recapByDay.items['jour'] && recapByDay.items['jour'] != null ? map(recapByDay.items['jour'], constructDayBloc) : null}
            </div>
          </TabPane>
          <TabPane tab=" Mois" key="month">
            <div className="pt-4 scroll-div-recap w-48">
              {recapByDay.items['month'] && recapByDay.items['month'] !== null ? map(recapByDay.items['month'], constructMonthBloc) : null}
            </div>
          </TabPane>
        </Tabs>
        <div className="flex pt-3 absolute " style={{ right: '0' }}>
          <div className="ml-2" style={{ cursor: 'pointer' }} onClick={getCsvFile}>
            <Icon type="file-excel" style={{ fontSize: '20px', color: '#2495e1' }} />
          </div>

          <div className="ml-2" style={{ cursor: 'pointer' }} onClick={getPdfFile}>
            <Icon type="file-pdf" style={{ fontSize: '20px', color: '#2495e1' }} />
          </div>

        </div>

      </div>
      <div className="flex flex-row justify-between pt-4  pr-4 pb-4">
        <div className="border-right-line"> TOTAL</div>
        <div className="div-recap-amount-total"> {formatAmount(calculSum())} </div>
      </div>

    </div>
  );
}

const mapStateToProps = state => ({
  statisticsFilter: state.filters.statisticsFilter,
  recapByDay: state.recapByDay,
  auth: state.auth,
});

const mapDispatchToProps = {
  getRecapByDay,
  setFilterInvoicesByDay,
  displayRecapPaymentCsvFile,
  displayRecapPaymentPdfFile
};

export default connect(mapStateToProps, mapDispatchToProps)(RecapByDate);



// WEBPACK FOOTER //
// ./app/components/Admin/statisctics/RecapByDate.js